// Styles
import './CustomPaging.scss';

// Libs
import React, { useEffect, useMemo, useState } from 'react';

// Components
import Picture from '@/common/components/atoms/Picture/Picture';
// Constants
import { MEDIA_TYPES, VIMEO_REGEX } from '@/common/constants';
// Helpers
import getVideoThumbnail from '@/common/helpers/getVideoThumbnail';
// Hooks
import useVideoInfo from '@/common/hooks/vimeo/useVideoInfo';

import { CustomDefaultProps, CustomPropTypes } from './CustomPaging.proptypes';

const CustomPaging = ({ alt, path, type }) => {
  const [newPath, setNewPath] = useState(path);
  const [videoId, setVideoId] = useState(null);

  const { data: video } = useVideoInfo(videoId);

  const classNames = useMemo(
    () =>
      // TODO: Clean classNames
      ['slider-media__nav-item', `slider-media__nav-item--${type}`]
        .filter((val) => val)
        .join(' '),
    [type],
  );

  useEffect(() => {
    if (type === MEDIA_TYPES.VIDEO) {
      if (path.match(VIMEO_REGEX)) {
        setVideoId(path.match(VIMEO_REGEX)[1]);
      }

      setNewPath(getVideoThumbnail(path, video || null));
    }
  }, [path, type, video]);

  return (
    // TODO: Clean classNames
    <div className={classNames} data-qa-id="custom-paging">
      <Picture src={newPath} alt={alt} className="slider-media__nav-image" />
    </div>
  );
};

CustomPaging.defaultProps = {
  ...CustomDefaultProps,
};

CustomPaging.propTypes = {
  ...CustomPropTypes,
};

export default CustomPaging;
